import React from 'react'
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'

export const TradeLine = (props: any) => {

  const {
    xData = [],
    yData = [[], []],
  } = props

  const getOption = () => {
    return {
      title: {
        text: '营业额/应收金额',
        textStyle: {
          fontSize: 21
        }
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['营业额', '应收金额'],
          width: 500,
          top: 10,
          right: -5,
          textStyle: {
            fontSize: 16
          }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: xData
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: '营业额',
          type: 'line',
          data: yData[0]
        },
        {
          name: '应收金额',
          type: 'line',
          data: yData[1]
        }
      ]
    };
  }

  return (
    <ReactEchartsCore
      echarts={echarts}
      option={getOption() as echarts.EChartOption<echarts.EChartOption.Series>}
      style={{ height: '90%' }}
    />
  )
}